// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardIva_wrapper__xusYt","content":"DashboardIva_content__+1jMF","empty":"DashboardIva_empty__yWP-6"};